
import React from 'react';
import { Anchor, Box, Meter, Stack, Table, TableBody, TableCell, TableRow, Text } from 'grommet';

import { percentToString } from '../../utils';

function filterOdrudy(odrudaTratId, tratContent, showAll) {
    let newTratContent = tratContent.filter(item => {
        return item.odruda_trat_id === odrudaTratId;
    });

    if (showAll !== true) {
        newTratContent = newTratContent.slice(0, 5);
    }

    return newTratContent;
}

const OdrudaNameCell = ({nazev, odrudaId}) => {
    return odrudaId
        ? <Anchor size="small" label={nazev} href={`#/odruda/${odrudaId}`} />
        : <Text size="small" style={{fontWeight: 600}} >{nazev}</Text>;
}

const ValueLabel = ({value}) => {
    return (
        <Text size="10px">{percentToString(value)}</Text>
    )
}

const OdrudaValueCell = ({value}) => {
    return (
        <Stack anchor="center">
            <Meter
                values={[{
                    value: value,
                    color: 'accent-1'
                }]}
                thickness="small"
                size="xsmall"
                background="light-5"
                margin={{top: '6px'}}
            />
            <ValueLabel value={value} />
        </Stack>
    );
}

const OdrudaList = ({odrudaTratId, tratContent, showAll}) => {
    return (
        <Table>
            <TableBody>
                {filterOdrudy(odrudaTratId, tratContent, showAll).map(row => {
                    return (
                        <TableRow key={row.id}>
                            <TableCell>
                                <OdrudaNameCell nazev={row.odruda_nazev} odrudaId={row.odruda_id} />
                            </TableCell>
                            <TableCell>
                                <OdrudaValueCell value={row.value} />
                            </TableCell>
                        </TableRow>
                    );
                })}
            </TableBody>
        </Table>
    );
}

const OdrudyTratYear = ({odrudaTrat, tratContent, showAll}) => {
    return (
        <Box direction="column" background="light-2" gap="small" pad="small" margin="small" width="300px">
            <Box>
                <Text>{odrudaTrat.title}</Text>
            </Box>
            <Box align="center">
                <OdrudaList
                    odrudaTratId={odrudaTrat.odrudaTratId}
                    tratContent={tratContent}
                    showAll={showAll}
                />
            </Box>
        </Box>
    )
};

export default OdrudyTratYear;
